import { useContextState } from "../../../../../../hooks/theme"


export const useStyles = () => {
    const { colors: color } = useContextState()

    return {
        baseModal: {
            width: '60vw',
            padding: '8px 16px 16px 8px',
            height: '800px',
        },
        closeSuccess: {
            width: '100%',
            display: 'flex',
            justifyContent: 'end'
        },
        containerBody: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            overflow: 'auto',
            //scrollbarWidth: 'none',
        },
        buttonsContainer: {
            marginTop: '10px',
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .back': {
                width: '80px',
                height: '36px',
            },
            '& .next': {
                borderRadius: '4px',
            },
        },
        title: {
            fontWeight: 'bold',
            fontSize: '20px',
            marginLeft:1
        },
        containerSuccess: {
            width: '100%',
            height: '100%',
            margin: 'auto',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
        },
        titleRight: {
            height: '40px',
            marginBottom: 2,
            display: "flex",
            alignItems: "center",
        },
        list: {
            width: '100%',
            height: '546px',
        },
        empty: {
            width: '100%',
            fontSize: '20px',
            fontWeight: '400',
            color: color.color13,
            textAlign: 'center',
            padding: '20px 0',
            marginTop: 3
        },
        divider: {
            width: "95%",
            margin: "0 auto",
            borderBottomWidth: "3px",
        },
        userContainer: {
            padding: '4px 8px',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            color: color.color13,
            marginBottom: 2,
            '& .MuiSvgIcon-root': {
                fontSize: '28px'
            },
            '& .closeIcon': {
                '& .MuiSvgIcon-root': {
                    fontSize: '24px'
                },
            },
        },
        userBox: {
            border: `1px solid ${color.color32}`,
            borderRadius: 1
        },
        name:{
            wordWrap: 'break-word'
        },
        containerText: {
            flex: '1 1 50px',
            minWidth: '50px',
        },
        buttonClose: {
            '&.MuiIconButton-root': {
                padding: '0px'
            }
        },
        containerTitle:{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '7px',
        },
        headerTable: {
            '&.MuiTableCell-head': {
                minWidth: '100px',
            },
            '&.MuiTableCell-root.MuiTableCell-root': {
                vertialAlign: 'middle',
            },
        },
        paper: {
            padding: 2,
            '&.mt':{
                marginTop:2,
                minHeight: '550px'
            },
            '&.left':{
                margin: '0px 8px 0px 0px',
                display: 'flex',
                flexDirection: 'column',
                gap: 2
                //minHeight: '550px'
            },
            '& .MuiPaper-root':{
                maxHeight:'421px',
            }
        },
        containerTable:{
            marginLeft: 1
        }
    }
}